import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

// 👉 Déplacé hors du composant
const allTestimonials = [
  { name: "Sophie L.", text: "Un service exceptionnel ! J'ai trouvé mon vol en quelques clics et l'équipe m'a aidée pour toutes mes questions.", rating: 5 },
  { name: "Karim D.", text: "Site moderne, intuitif et rapide. Je recommande vivement pour organiser vos voyages.", rating: 4 },
  { name: "Julie P.", text: "Des offres variées et un accompagnement personnalisé. Merci Djater Voyage !", rating: 5 },
  { name: "Amadou K.", text: "J'ai réservé un circuit en famille, tout était parfaitement organisé. Bravo !", rating: 5 },
  { name: "Fatou B.", text: "Excellent rapport qualité-prix et un suivi client remarquable.", rating: 4 },
  { name: "Nadia T.", text: "J'apprécie la transparence et la clarté des informations. Je réserve à nouveau bientôt.", rating: 5 },
  { name: "Olivier M.", text: "La réservation a été simple et rapide. Aucun souci pendant mon voyage.", rating: 4 },
  { name: "Mariam C.", text: "J'ai découvert des destinations incroyables grâce à Djater Voyage.", rating: 5 },
  { name: "Jean-Paul R.", text: "Le site propose toujours des promotions intéressantes. J'ai économisé beaucoup !", rating: 5 },
  { name: "Claudine F.", text: "Un accompagnement professionnel du début à la fin. Merci pour cette belle expérience.", rating: 5 },
  { name: "Issa S.", text: "J’ai été impressionné par la qualité du service client. Réponses rapides et efficaces.", rating: 4 },
  { name: "Aïcha G.", text: "Tout était bien organisé : transport, hébergement, activités. Je recommande vivement.", rating: 5 },
  { name: "Patrick D.", text: "Les circuits proposés sont originaux et très enrichissants.", rating: 4 },
  { name: "Salimata Y.", text: "Mes enfants et moi avons passé des vacances inoubliables grâce à Djater Voyage.", rating: 5 },
  { name: "Franck E.", text: "Un service digne des grandes agences mais avec une touche locale chaleureuse.", rating: 5 },
];

const Temoignages = () => {
  const testimonials = useMemo(() => {
    const shuffled = [...allTestimonials].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, 3);
  }, []); // ✅ tableau vide, plus de warning

  return (
    <section className="container mx-auto px-4 mb-12">
      <h2 className="text-3xl font-bold text-blue-700 mb-6">💬 Témoignages de nos voyageurs</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {testimonials.map((t, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: idx * 0.12 }}
            className="bg-white rounded-2xl shadow-xl p-7 flex flex-col items-center border-2 border-blue-100 hover:shadow-2xl transition"
          >
            <div className="flex gap-1 mb-3">
              {[...Array(t.rating)].map((_, i) => (
                <Star key={i} className="text-yellow-400 w-6 h-6" />
              ))}
            </div>
            <p className="text-gray-700 italic mb-3 text-center">"{t.text}"</p>
            <div className="font-bold text-blue-800">{t.name}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Temoignages;
